
import { Component, Vue, Prop } from 'vue-property-decorator'
import { limitTypeList, prizeTypeList } from './../../index'
import { handleFill } from '@/utils/util'

@Component
class ConfigPrizeSetting extends Vue {
  @Prop({ default: () => ({}) }) formData!: any

  handleFill = handleFill

  fillModeList = [
    {
      label: '自动填充',
      value: 1
    },
    {
      label: '手动填充',
      value: 2
    }
  ]

  // 限制对象类型文本
  limitTypeText(type: number): string {
    const item = limitTypeList.find((l) => l.value === Number(type))
    return (item && item.label) || '--'
  }

  // 获取奖品类型标签
  getPrizeTypeLabel(prizeType: number) {
    const item = prizeTypeList.find((p) => p.value === Number(prizeType))
    return item.label || '--'
  }
}
export default ConfigPrizeSetting
